import {
  Grid,
  Box,
  Typography,
  FormControl,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";
import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";
import images from "../../../../../global-styles/images";

const renderScreenshotIcon = ({
  width = "30px",
  height = "30px",
  branding,
}: {
  width: string;
  height: string;
  branding: any;
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 938.000000 938.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,938.000000) scale(0.100000,-0.100000)"
        fill={branding?.[brandingConstants.inputFieldTextColor]}
        stroke="none"
      >
        <path
          d="M1368 8780 c-112 -9 -142 -23 -211 -100 -89 -98 -82 -22 -85 -925 -3
            -829 5 -1111 31 -1161 26 -48 109 -122 170 -149 80 -37 174 -37 254 0 61 27
            144 101 169 148 22 41 34 218 34 513 0 143 3 430 7 637 l6 377 476 1 c262 0
            591 4 733 8 293 10 315 15 387 98 61 69 85 126 89 213 5 99 -21 170 -89 244
            -76 83 -92 87 -389 97 -308 10 -1446 9 -1582 -1z"
        ></path>
        <path
          d="M4450 8781 c-101 -5 -121 -9 -161 -33 -54 -32 -109 -90 -141 -150
            -19 -36 -23 -58 -23 -138 0 -85 3 -101 29 -149 35 -67 113 -145 163 -163 30
            -10 190 -13 798 -13 418 0 781 4 808 8 38 7 59 19 107 63 83 78 114 144 114
            249 1 97 -27 163 -101 239 -73 74 -86 78 -348 87 -255 9 -1065 9 -1245 0z"
        ></path>
        <path
          d="M7184 8781 l-141 -6 -56 -37 c-156 -104 -201 -302 -103 -457 28 -43
            107 -118 139 -130 48 -19 203 -24 842 -30 l660 -6 6 -645 c8 -741 11 -818 40
            -877 23 -47 94 -115 149 -143 83 -43 205 -43 286 -2 61 31 130 98 156 150 l23
            47 0 960 c0 1074 6 987 -74 1077 -76 86 -94 90 -410 99 -309 9 -1300 9 -1517
            0z"
        ></path>
        <path
          d="M2155 5720 c-268 -10 -323 -18 -431 -59 -128 -49 -237 -123 -350
            -235 -179 -180 -266 -357 -305 -624 -11 -70 -16 -83 -33 -87 -12 -2 -61 -11
            -111 -20 -400 -69 -702 -327 -830 -708 -43 -129 -47 -248 -42 -1407 5 -1171 3
            -1144 67 -1308 100 -261 394 -531 645 -596 148 -37 232 -39 2110 -43 1906 -4
            2412 2 2520 31 78 21 210 85 297 142 143 95 295 277 368 439 67 150 70 169 82
            630 11 464 4 1800 -12 1955 -30 309 -253 615 -560 770 -95 48 -187 77 -308 96
            -59 10 -112 22 -118 28 -6 6 -16 48 -23 93 -42 287 -169 516 -381 686 -157
            125 -318 191 -508 208 -150 13 -1774 20 -2077 9z m1610 -679 c514 -9 498 -6
            580 -82 87 -80 98 -124 115 -464 5 -110 15 -218 21 -240 15 -55 81 -139 132
            -169 55 -32 130 -44 370 -56 211 -11 267 -19 327 -50 50 -25 127 -120 137
            -168 4 -20 8 -541 8 -1157 l0 -1120 -23 -47 c-27 -54 -97 -123 -150 -146 -32
            -14 -121 -17 -667 -23 -1374 -16 -3621 -4 -3696 20 -48 15 -153 124 -170 177
            -16 49 -25 1948 -11 2171 10 156 18 177 93 253 68 68 117 77 510 99 186 11
            211 18 282 81 87 77 100 124 117 431 17 306 27 343 113 413 92 73 80 70 322
            77 337 8 1078 8 1590 0z"
        ></path>
        <path
          d="M2978 4020 c-77 -9 -156 -30 -248 -66 -293 -115 -544 -406 -622 -720
            -33 -133 -31 -333 5 -466 78 -292 301 -559 570 -683 139 -64 340 -102 477 -90
            259 23 467 119 645 299 89 89 144 165 197 271 312 620 -101 1367 -806 1455
            -89 11 -120 11 -218 0z m225 -690 c79 -25 155 -89 195 -164 24 -45 27 -62 27
            -151 0 -118 -20 -171 -95 -245 -65 -66 -128 -94 -222 -98 -66 -4 -84 -1 -135
            22 -70 33 -145 103 -181 171 -23 43 -27 62 -27 140 0 76 4 98 26 145 28 59 94
            132 143 157 89 46 171 53 269 23z"
        ></path>
        <path
          d="M8783 5721 c-53 -14 -118 -58 -171 -116 -40 -43 -53 -66 -59 -103
            -10 -62 -10 -1523 0 -1585 7 -38 19 -59 63 -107 79 -84 145 -115 249 -115 104
            0 170 31 249 115 44 48 56 69 63 107 10 63 10 1523 0 1586 -11 61 -93 154
            -173 193 -59 29 -161 40 -221 25z"
        ></path>
        <path
          d="M8803 2999 c-61 -12 -101 -33 -160 -84 -93 -81 -95 -92 -104 -439 -4
            -166 -8 -495 -8 -732 l-1 -431 -31 -7 c-17 -3 -262 -6 -543 -6 -597 -1 -885
            -11 -936 -32 -46 -20 -136 -116 -163 -175 -33 -74 -31 -190 6 -265 40 -82 132
            -164 194 -175 27 -4 467 -8 978 -8 761 0 937 2 969 14 55 19 152 119 168 173
            10 34 13 241 13 993 l0 950 -23 47 c-61 124 -224 204 -359 177z"
        ></path>
      </g>
    </svg>
  );
};

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  technology: string;
  handleBtnPosition: (category: any) => void;
  ClickedCat: any;
  ClickedCatFbsVal: any;
}

const FourthPagePreview = ({
  product,
  previewAgent,
  branding,
  ClickedCatFbsVal,
  ClickedCat,
  technology,
}: IProps) => {
  return (
    <Grid item xs={12} mt={previewAgent ? "35px" : "15px"}>
      <Grid item xs={12}>
        <Grid
          item
          container
          alignItems="center"
          sx={{
            marginBottom: previewAgent ? "20px" : "15px",
          }}
        >
          <Typography
            dangerouslySetInnerHTML={{
              __html: product?.feedbackSettings?.dialogMsg,
            }}
            sx={{
              color: branding?.[brandingConstants.inputLabelColor],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontSize: handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
              "& p": {
                margin: 0,
              },
            }}
          />

          <span
            style={{
              color: branding?.[brandingConstants.inputLabelColor],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontSize: handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
            }}
          >
            (Optional)
          </span>
        </Grid>

        <Typography
          sx={{
            color: branding?.[brandingConstants.attachmentHelperTextColor],
            fontSize: handleConvertPxToPt(
              branding?.[brandingConstants.attachmentHelperFontSize],
              previewAgent
            ),
            fontStyle: branding?.[brandingConstants.attachmentHelperFontStyle],
            fontFamily:
              branding?.[brandingConstants.attachmentHelperFontFamily],
            fontWeight:
              branding?.[brandingConstants.attachmentHelperFontWeight],
          }}
        >
          Note: {product?.feedbackSettings?.attachmentHelp}
        </Typography>
      </Grid>

      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        sx={{
          marginTop: previewAgent ? "40px" : "20px",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: previewAgent ? "200px" : "150px",
            border:
              "1px solid" +
              branding?.[brandingConstants?.inputFieldBorderColor],
            borderRadius: branding?.[brandingConstants.inputFieldBorderRadius],
            background: branding?.[brandingConstants.inputFieldBGColor],
            padding: previewAgent ? "10px" : "15px",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              marginRight: previewAgent ? "10px" : "5px",
              position: "relative",
              top: "2px",
            }}
          >
            {/* <img
              src={images.screenshotIcon}
              alt="icon"
              style={{
                width: previewAgent ? "50px" : "30px",
                height: previewAgent ? "50px" : "30px",
              }}
            /> */}
            {renderScreenshotIcon({
              width: previewAgent ? "32px" : "20px",
              height: previewAgent ? "32px" : "20px",
              branding,
            })}
          </Box>
          <Box
            sx={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontSize: handleConvertPxToPt(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
            }}
          >
            SCREENSHOT
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FourthPagePreview;
